import React, { FC } from "react"
import {
  Heading,
  Description,
  Paragraph,
  Highlight,
  Caution,
  URLList,
} from "shared/components"
import { CAUTION_SIZE, marginTop } from "shared/utils/styles"
import {
  PARAGRAPHS,
  REASONS_FOR_COLLECTING_INFORMATION,
  SHARING_YOUR_INFORMATION,
  COLLECTION_OF_INFORMATION,
  GENERAL_SUBLIST,
  COLLECTION_OF_INFORMATION_AND_TRACKING_SUBLIST,
} from "../content/privacy"
/** @jsx jsx */
import { jsx } from "@emotion/react"
import { gzpUrls } from "../content/common-content"
const PrivacyPolicyView: FC = () => {
  return (
    <div className="main-content-container">
      <Heading>Privacy and Cookie Policy</Heading>
      <div css={marginTop(20)} />
      <Description>Last updated on 29th December, 2022.</Description>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_1}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_2}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_3}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_4}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_5}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_6}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_7}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_8}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_9}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_10}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_11}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_12}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_13}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_14}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_15}</Paragraph>
      <Paragraph>
        <>
          <ol className="lower-alpha">
            <li className="heading">
              COLLECTION OF INFORMATION
              <div css={marginTop(40)} />
              <ol>
                {COLLECTION_OF_INFORMATION.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
                <div css={marginTop(40)} />
              </ol>
            </li>
            <li className="heading">
              REASONS FOR COLLECTING INFORMATION
              <div css={marginTop(40)} />
              <Paragraph>
                We use Your Personal Information and other information to
                maintain the general and personalized content and functionality
                of Platform and / or Content. In addition, We use personal
                details to make it possible to accommodate Your requests. We
                will use and retain Your information for such periods as
                necessary to comply with Our legal obligations, resolve
                disputes, and enforce Our agreements, including the Agreement.
                <div css={marginTop(20)} />
                More specifically, it may be used for one or more of the
                indicative reasons provided below:
              </Paragraph>
              <ol>
                {REASONS_FOR_COLLECTING_INFORMATION.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ol>
            </li>
            <li className="heading">
              SHARING YOUR INFORMATION
              <div css={marginTop(40)} />
              <ol>
                {SHARING_YOUR_INFORMATION.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ol>
            </li>
            <li className="heading">
              PROTECTING YOUR INFORMATION
              <Paragraph>
                Your information is important to Us. We use reasonable
                safeguards as per industry standards to preserve the integrity
                and security of Your information against loss, theft,
                unauthorised access, disclosure, reproduction, use, or
                amendment. To achieve the same, We use reasonable security
                practices and procedures for the protection of Your information.
                However, no commercial method of information transfer over the
                internet or electronic data storage is known to be 100% secure.
                As a result, We cannot guarantee the absolute security of that
                information, including Personal Information during its
                transmission or its storage in Our systems. Be advised that if
                You send messages or post material containing Personal
                Information, that information may be collected and used by
                others.
                <div css={marginTop(20)} />
                We store and process Your Personal Information on cloud servers
                provided by Amazon Web Services (“<b>AWS</b>”) and Microsoft
                Azure (“<b>Azure</b>”), and We may partner with other cloud
                service providers in future. AWS, Azure, and other cloud service
                providers that We may partner with in future are collectively
                referred to as “<b>Cloud Service Providers</b>”. Currently, all
                Your information, including Your Personal Information are stored
                by AWS in servers located in Mumbai, India and Azure servers in
                Pune, India. However, in future, all Your information, including
                Your Personal Information, may be maintained by Cloud Service
                Providers on servers or databases located outside India or to a
                jurisdiction where the privacy laws may not be the same as those
                in Your location, region, or country. By using Our offerings
                through Platform and / or Content, You consent to the transfer
                of such information to the Cloud Service Providers and to
                maintenance and storage of Your Personal Information in
                jurisdictions other than Your jurisdiction. All information,
                including Personal Information You provide to Us may be stored
                in locations outside India.
                <div css={marginTop(20)} />
                Notwithstanding anything contained in this Policy or elsewhere,
                the Company shall not be held responsible for any loss, damage,
                or misuse of Your Personal Information, if such loss, damage or
                misuse is attributable to a Force Majeure Event (
                <i>as defined below</i>). For the purposes of this Policy, a "
                <b>Force Majeure Event</b>" shall mean any event that is beyond
                Our reasonable control and shall include, without limitation,
                sabotage, fire, flood, explosion, acts of God, civil commotion,
                strikes or industrial action of any kind, riots, insurrection,
                war, acts of government, pandemics, computer hacking,
                unauthorised access to computer, computer system or computer
                network, computer crashes, breach of security and encryption
                (provided beyond Our reasonable control), power or electricity
                failure, or unavailability of adequate power or electricity.
                <div css={marginTop(20)} />
                You agree and acknowledge that We may retain a copy of all
                information provided by You as per Our security, recovery, and
                back-up policies effective at such points in time, even if You
                stop using Platform and / or Content.
              </Paragraph>
            </li>
            <li className="heading">
              GENERAL
              <div css={marginTop(40)} />
              <ol>
                {GENERAL_SUBLIST.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ol>
            </li>
          </ol>
        </>
      </Paragraph>
    </div>
  )
}

export default PrivacyPolicyView
